import React, { useEffect, useState } from 'react';
import { Button } from 'components/buttons/Button/Button';
import uniferIcon from 'images/icons/uniferIcon.svg';
import './styles.scss';

const YoutubeLink = ({ videoId }) => {
    const [videoData, setVideoData] = useState(null);
    const apiKey = 'AIzaSyAbauN0JyjmPayAaRWiU7N3ZW3XlZJ2lGY';

    const onOpenLink = () => {
        const linkToOpen = `https://www.youtube.com/watch?v=${videoId}`;
        window.open(linkToOpen, '_blank');
    };

    useEffect(() => {
        const fetchYoutubeData = async () => {
            try {
                const response = await fetch(
                    `https://www.googleapis.com/youtube/v3/videos?id=${videoId}&key=${apiKey}&part=snippet`,
                );

                if (response.ok) {
                    const data = await response.json();
                    setVideoData(data.items[0].snippet);
                } else {
                    console.error('Failed to fetch video data');
                }
            } catch (error) {
                console.error('Error fetching video data', error);
            }
        };

        fetchYoutubeData();
    }, []);

    if (!videoData) {
        return <div>Loading...</div>;
    }

    const { title, thumbnails } = videoData;
    const thumbnailUrl = thumbnails && thumbnails.high && thumbnails.high.url;

    return (
        <div className="youtube-link">
            <div className="youtube-link__title">
                <img src={uniferIcon} alt="uniferX icon" />
                <p className="description-demibold">{title}</p>
            </div>
            <Button
                type="youtube"
                className="youtube-link_button"
                href="https://www.youtube.com/watch?v=KPhzCco_ku4"
                onClick={onOpenLink}
            />
            {thumbnailUrl && <img src={thumbnailUrl} alt="Video Thumbnail" className="youtube-link__image" />}
        </div>
    );
};

export default YoutubeLink;
